import "./Swatch.css"

const Swatch = ({ id, url, handleAddSwatch, inPalette}) => {

    const displayItem = 
    <div className='swatch'>      
        <img src={url}  alt="pic" className={inPalette ? "image2" : "image"} onClick={() => handleAddSwatch({id, url, selected:true})}/>
        <p className={inPalette ? "deleteButton": "deleteButtonOff"}>x</p>
        <p className="photoLabel">{`${id}`}</p>  
    </div>

    return (
        <>
        {displayItem}
        </>
    )
}

export default Swatch
